import { combineReducers } from "redux";

import { unregisteredUsersDetails } from "./reducer.users"
const userReducers = combineReducers({

  unregisteredUsersDetails

})
export default userReducers;
